import { useContext, useEffect } from 'react'

import Loading from 'components/Loading'
import { DefaultsPageContext } from 'features/globalSetup/contexts/DefaultsPageContext'
import { FormContainer } from 'features/globalSetup/forms/Defaults/FormContainer'
import { useGetWorkspacePrebidConfiguration } from 'features/globalSetup/hooks/useGetWorkspacePrebidConfiguration'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'

export const PrebidDefaultsPage = (): JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const {
    prebid: { setWorkspaceConfig, workspaceConfig },
  } = useContext(DefaultsPageContext)

  const { workspacePrebidConfiguration: configApi } = useGetWorkspacePrebidConfiguration({
    workspaceId,
  })

  useEffect(() => {
    if (configApi) {
      setWorkspaceConfig(configApi)
    }
  }, [setWorkspaceConfig, configApi])

  if (!configApi || !workspaceConfig) {
    return <Loading />
  } else {
    return <FormContainer />
  }
}
